module.exports = __webpack_public_path__ + "media/images/nounslogo-c11aa317.png";